
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import axios from 'axios'
import CommonUtils from '@/common-utils'
import { WrongAnswerNoteOVO } from '@/views/biz/note/vo/WrongAnswerNote.vo'
import PieChart from '@/components/PieChart.vue'
import ComboChart from '@/components/ComboChart.vue'

@Component({
  components: {PieChart, ComboChart }
})
export default class QuestionAnalysisDialog extends Vue {
  @Prop() questionAnalysisDialog !: boolean;
  @Prop() emNo !: string;
  @Prop() questionNumber !: number;

  // 내 성적
  myGrade: WrongAnswerNoteOVO = {} as WrongAnswerNoteOVO;
  // 전체 성적
  allGrade: WrongAnswerNoteOVO = {} as WrongAnswerNoteOVO;
  // 답항별 마킹 개수
  reportAnswers: Array<WrongAnswerNoteOVO> = [] as Array<WrongAnswerNoteOVO>;
  // 날짜별 제출 정보
  reportDate: Array<WrongAnswerNoteOVO> = [] as Array<WrongAnswerNoteOVO>;

  // 도움말 메시지
  msgDialog = false;
  currentHelpMsg = {};
  converterDuplicationAnswerHelpMsg = {
    title: '중복 정답표',
    msg: '정답이 여러개인 문제는 A-K까지의 알파벳으로 표기돼요. 알파벳 정답이 가리키는 답항으로 자동으로 변환해줘요.',
  };

  // 중복 답안 분리
  get duplicationAnswerParserList() {
    const answers = [] as Array<string>;
    for(let i = 0; i < this.myGrade.oaMatchAnsr.length; i ++) {
      answers.push(this.myGrade.oaMatchAnsr.charAt(i));
    }
    return answers;
  }
  
  // 모름을 선택한 비중
  get getUnknownCount() {
    const result = this.reportAnswers.filter( (v) => v.uaSvAnsr == '0');
    return result.length ? `${result[0].groupCnt}`: 0;
  }

  get getQuestionType() {
    return CommonUtils.getQuestionType(this.myGrade);
  }

  getMarkingAnswerByQuestionNumber(idx: string) {
    const result = this.reportAnswers.filter( (v) => v.uaSvAnsr == idx)
    return result.length ? `${result[0].groupCnt}`: 0;
  }

  getWindowSize(){
    switch (this.$vuetify.breakpoint.name) {
      case 'xs': return 220
      case 'sm': return 400
      case 'md': return 500
      case 'lg': return 600
      case 'xl': return 800
    }
  }

  closeDialog(): void {
    this.$store.dispatch(`questionsAnalysis/closeModal`, {name: 'questionsAnalysis'});
  }

  outsideClickEventHandler() {
    this.closeDialog();
  }

  escKeyDownEventHandler(e) {
    if(e.keyCode != 27) {
      return;
    }
    this.closeDialog();
  }

  // 도움말
  openHelpMessages(msg): void {
    this.msgDialog = !this.msgDialog;
    this.currentHelpMsg = msg;
  }

  @Watch('$store.state.questionsAnalysis.opened')
  init(): void {
    if(this.$store.state.questionsAnalysis.opened == false) {
      this.myGrade = {} as WrongAnswerNoteOVO;
      this.allGrade = {} as WrongAnswerNoteOVO;
      this.reportAnswers = [] as Array<WrongAnswerNoteOVO>;
      return;
    }

    axios.get(`/wrong-answer-note/analysis/question/${this.emNo}/${Math.floor(this.questionNumber)}`)
    .then(r => {
      this.myGrade = r.data.myGrade;
      this.allGrade = r.data.allGrade;
      this.reportAnswers = r.data.reportAnswers;
      this.reportDate = r.data.reportDate;
    })
  }


}
